export default __webpack_public_path__ + "static/media/Interamplify.0bcb96c7.webp";